import { render, staticRenderFns } from "./IngredientesTable.vue?vue&type=template&id=d0826c44"
import script from "./IngredientesTable.vue?vue&type=script&lang=js"
export * from "./IngredientesTable.vue?vue&type=script&lang=js"
import style0 from "./IngredientesTable.vue?vue&type=style&index=0&id=d0826c44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports